import type { JSX } from 'react';
import React from 'react';

import type { EEmailABTestStatus, TEmailABTestVariation } from '@feathr/blackbox';
import EmailABTestVersionPill from '@feathr/extender/components/EmailABTestVersionPill';

import ABTestPill from './ABTestPill';

interface IProps {
  status?: EEmailABTestStatus;
  variation: TEmailABTestVariation;
}

function ABTestVersionPills({ status, variation }: Readonly<IProps>): JSX.Element {
  return (
    <>
      <EmailABTestVersionPill variation={variation} />
      {status && <ABTestPill placement={'version'} status={status} />}
    </>
  );
}

export default ABTestVersionPills;
